"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpflowyStoreCollectionData = exports.useUpflowyStoreDocData = exports.useUpflowyStoreRefs = exports.upflowyStoreRefs = exports.useUpflowyStore = exports.upQuery = exports.upDoc = exports.upCollection = void 0;
const firestore_1 = require("firebase/firestore");
const react_1 = require("react");
const reactfire_1 = require("reactfire");
// export type CollectionRefType<T extends CollectionTypeMap> = {
//   collection: <C extends T, K extends keyof C>(
//     collectionPath: K,
//   ) => {
//     doc: (
//       documentPath: string,
//     ) => C[K] extends { collections: CollectionTypeMap }
//       ? CollectionRefType<C[K]['collections']> &
//           Omit<FirestoreDocumentReference<C[K]['type']>, 'collection'>
//       : FirestoreDocumentReference<C[K]['type']>;
//   } & CollectionReference<C[K]['type']>;
// } & CollectionReference;
const upCollection = (collectionMap, col) => (0, firestore_1.collection)(collectionMap, col);
exports.upCollection = upCollection;
const upDoc = (collectionMap, docId) => (0, firestore_1.doc)(collectionMap, docId);
exports.upDoc = upDoc;
exports.upQuery = firestore_1.query;
/**
 * Typed react-fire useFirestore with Upflowy types
 */
function useUpflowyStore() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const firestore = (0, reactfire_1.useFirestore)(undefined, false);
    return firestore;
}
exports.useUpflowyStore = useUpflowyStore;
// function refType<T, R, TR>(
//   ref: T,
//   rest: (r: T) => R,
// ): R & { ref: T extends { refType: unknown } ? DocumentReference<T['refType']> : T };
function refType(ref, rest) {
    return {
        ref,
        ...rest === null || rest === void 0 ? void 0 : rest(ref),
    };
}
function activeRef(ref) {
    return () => refType((0, firestore_1.query)(ref, (0, firestore_1.where)('active', '==', true)));
}
function defaultRef(ref) {
    return () => refType((0, firestore_1.query)(ref, (0, firestore_1.where)('default', '==', true)));
}
function upflowyStoreRefs(upflowyStore) {
    return {
        layouts: () => refType((0, exports.upCollection)(upflowyStore, 'Layouts'), (layoutsRef) => ({
            active: () => refType((0, firestore_1.query)(layoutsRef, (0, firestore_1.where)('active', '==', true))),
            id: (id) => refType((0, exports.upDoc)(layoutsRef, id), (ref) => ({
                versions: () => refType((0, exports.upCollection)(ref, 'versions'), (versionRef) => ({
                    id: (versiondDoc) => refType((0, firestore_1.doc)(versionRef, versiondDoc)),
                    active: () => refType((0, firestore_1.query)(versionRef, (0, firestore_1.where)('active', '==', true), (0, firestore_1.limit)(1))),
                })),
            })),
        })),
        flows: () => refType((0, exports.upCollection)(upflowyStore, 'Flows'), (flowsRef) => ({
            id: (id) => refType((0, exports.upDoc)(flowsRef, id), (ref) => ({
                versions: () => refType((0, exports.upCollection)(ref, 'versions'), (versionRef) => ({
                    published: () => refType((0, firestore_1.query)(versionRef, (0, firestore_1.where)('status', '==', 'PUBLISHED'))),
                    draft: () => refType((0, firestore_1.query)(versionRef, (0, firestore_1.where)('status', '==', 'DRAFT'))),
                    id: (versiondDoc) => refType((0, exports.upDoc)(versionRef, versiondDoc), (versiondRefDoc) => ({
                        steps: () => refType((0, exports.upCollection)(versiondRefDoc, 'steps'), (stepsRef) => ({
                            id: (stepsRefdDoc) => refType((0, exports.upDoc)(stepsRef, stepsRefdDoc)),
                        })),
                        assets: () => refType((0, exports.upCollection)(versiondRefDoc, 'assets'), (assetsRef) => ({
                            id: (assetsRefDoc) => refType((0, exports.upDoc)(assetsRef, assetsRefDoc)),
                            customCss: () => refType((0, firestore_1.query)(assetsRef, (0, firestore_1.where)('name', '==', 'custom-css'))),
                            withoutCustomCss: () => refType((0, firestore_1.query)(assetsRef, (0, firestore_1.where)('name', '!=', 'custom-css'))),
                        })),
                        triggers: () => refType((0, exports.upCollection)(versiondRefDoc, 'triggers'), (triggerRef) => ({
                            id: (triggerId) => refType((0, exports.upDoc)(triggerRef, triggerId)),
                        })),
                        webhooks: () => refType((0, exports.upCollection)(versiondRefDoc, 'webhooks'), (webhooRef) => ({
                            private: async () => {
                                const qry = await (0, firestore_1.getDocs)(webhooRef);
                                return Promise.all(qry.docs.map(async (ddd) => {
                                    const p = await (0, firestore_1.getDoc)((0, exports.upDoc)((0, exports.upCollection)((0, exports.upDoc)(webhooRef, ddd.id), 'private'), ddd.id));
                                    return {
                                        ...ddd.data(),
                                        ...p.data(),
                                    };
                                }));
                            },
                            id: (webhookDoc) => refType((0, exports.upDoc)(webhooRef, webhookDoc), (webhookRef) => ({
                                private: () => refType((0, exports.upCollection)(webhookRef, 'private'), (privateWebHook) => ({
                                    id: (privateWebHookId) => refType((0, exports.upDoc)(privateWebHook, privateWebHookId)),
                                })),
                            })),
                        })),
                    })),
                })),
                events: () => refType((0, exports.upCollection)(ref, 'events'), (eventsRef) => ({
                    first: (cnt = 10) => refType((0, exports.upQuery)(eventsRef, (0, firestore_1.orderBy)('createdAt'), (0, firestore_1.limit)(cnt))),
                })),
                exports: () => refType((0, exports.upCollection)(ref, 'exports'), (exportsRef) => ({
                    orderByDateDesc: () => refType((0, exports.upQuery)(exportsRef, (0, firestore_1.orderBy)('createdAt', 'desc'))),
                })),
            })),
            byOrganisationId: (organisationId) => refType((0, exports.upQuery)(flowsRef, (0, firestore_1.where)('organisationId', '==', organisationId), (0, firestore_1.where)('deletedAt', '==', null), (0, firestore_1.orderBy)('createdAt', 'desc'))),
        })),
        experienceTypes: () => refType((0, exports.upCollection)(upflowyStore, 'ExperienceTypes'), (ref) => ({
            active: activeRef(ref),
            default: defaultRef(ref),
            id: (id) => refType((0, exports.upDoc)(ref, id), (docRef) => ({
                versions: () => refType((0, exports.upCollection)(docRef, 'versions'), (versionRef) => ({
                    active: activeRef(versionRef),
                    id: (versionId) => refType((0, exports.upDoc)(versionRef, versionId)),
                })),
            })),
        })),
        flowTemplates: () => refType((0, exports.upCollection)(upflowyStore, 'FlowTemplates'), (ref) => ({
            id: (id) => refType((0, exports.upDoc)(ref, id), (flowTemplateRef) => ({
                steps: () => refType((0, exports.upCollection)(flowTemplateRef, 'steps'), (stepsRef) => ({
                    id: (stepId) => refType((0, exports.upDoc)(stepsRef, stepId)),
                })),
                assets: () => refType((0, exports.upCollection)(flowTemplateRef, 'assets'), (assetsRef) => ({
                    id: (assetId) => refType((0, exports.upDoc)(assetsRef, assetId)),
                    active: () => refType((0, firestore_1.query)(assetsRef, (0, firestore_1.where)('active', '==', true))),
                })),
            })),
            active: activeRef(ref),
        })),
        organisations: () => refType((0, exports.upCollection)(upflowyStore, 'Organisations'), (organisationRef) => ({
            id: (id) => refType((0, exports.upDoc)(organisationRef, id), (ref) => ({
                staticAssets: () => refType((0, exports.upCollection)(ref, 'staticAssets'), (staticAssetsRef) => ({
                    id: (assetRef) => refType((0, exports.upDoc)(staticAssetsRef, assetRef)),
                })),
            })),
        })),
        stepTemplates: () => refType((0, exports.upCollection)(upflowyStore, 'StepTemplates'), (ref) => ({
            activeDefaultTemplate: () => refType((0, exports.upQuery)(ref, (0, firestore_1.where)('active', '==', true), (0, firestore_1.where)('defaultTemplate', '==', true))),
            stepTemplates: () => refType((0, exports.upQuery)(ref, (0, firestore_1.orderBy)('active', 'desc'))),
            id: (id) => refType((0, exports.upDoc)(ref, id)),
        })),
        assets: () => refType((0, exports.upCollection)(upflowyStore, 'Assets'), (assetsRef) => ({
            active: () => refType((0, firestore_1.query)(assetsRef, (0, firestore_1.where)('active', '==', true)), (assetsActiveRef) => ({
                group: (group) => refType((0, firestore_1.query)(assetsActiveRef, (0, firestore_1.where)('group', '==', group)), (groupRef) => ({
                    types: (types) => refType((0, firestore_1.query)(groupRef, (0, firestore_1.where)('type', 'in', types))),
                })),
            })),
            id: (id) => refType((0, exports.upDoc)(assetsRef, id)),
        })),
        themes: () => refType((0, exports.upCollection)(upflowyStore, 'Themes'), (themesRef) => ({
            active: () => refType((0, exports.upQuery)(themesRef, (0, firestore_1.where)('active', '==', true))),
            id: (id) => refType((0, exports.upDoc)(themesRef, id), (ref) => ({
                versions: () => refType((0, exports.upCollection)(ref, 'versions'), (versionRef) => ({
                    id: (versiondDoc) => refType((0, exports.upDoc)(versionRef, versiondDoc)),
                    active: () => refType((0, firestore_1.query)(versionRef, (0, firestore_1.where)('active', '==', true), (0, firestore_1.limit)(1))),
                })),
            })),
            default: () => refType((0, exports.upQuery)(themesRef, (0, firestore_1.where)('defaultTheme', '==', true), (0, firestore_1.limit)(1))),
        })),
        users: () => refType((0, exports.upCollection)(upflowyStore, 'Users'), (ref) => ({
            id: (id) => refType((0, exports.upDoc)(ref, id)),
        })),
    };
}
exports.upflowyStoreRefs = upflowyStoreRefs;
const useUpflowyStoreRefs = () => {
    const upflowyStore = useUpflowyStore();
    return (0, react_1.useMemo)(() => upflowyStoreRefs(upflowyStore), [upflowyStore]);
};
exports.useUpflowyStoreRefs = useUpflowyStoreRefs;
// Note the return of result in 'data' is to be more compatible with next release of reactfire
const useUpflowyStoreDocData = (ref, options) => (0, reactfire_1.useFirestoreDocData)(ref, options);
exports.useUpflowyStoreDocData = useUpflowyStoreDocData;
const useUpflowyStoreCollectionData = (qry, options) => (0, reactfire_1.useFirestoreCollectionData)(qry, options);
exports.useUpflowyStoreCollectionData = useUpflowyStoreCollectionData;
//# sourceMappingURL=use-upflowy-store.js.map